import { styled } from '@mui/material';
import { Editor } from '@tiptap/core';
import { useStore } from 'zustand';
import type { DragHandlerStore } from '../states/TableHandlerState';
import { TableHandlerStateProvider } from '../states/TableHandlerState';
import { TableColumnHandler } from './TableColumnHandler';
import { TableRowHandler } from './TableRowHandler';

export const TableHandles = ({
  editor,
}: {
  editor: Editor;
}) => {
  const dragHandlerState = editor.storage?.tableHandle
    ?.dragHandlerState as DragHandlerStore;

  if (!dragHandlerState) return null;

  const visible = useStore(dragHandlerState, (state) => state.visible);

  if (!visible) return null;

  return (
    <TableHandlerStateProvider store={dragHandlerState}>
      <StyledRoot>
        <TableColumnHandler editor={editor} />
        <TableRowHandler editor={editor} />
      </StyledRoot>
    </TableHandlerStateProvider>
  );
};

const StyledRoot = styled('div')(({ theme }) => ({
  position: 'absolute',
  zIndex: 99,
}));
